import { Autocomplete, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { globalGetService, globalPutService } from '../../../../utils/globalApiServices';
import { getLessorDropdown, getOwnerDropdown, putLessorApi } from '../apiServices';
import { enqueueSnackbar } from 'notistack';
import { checkApiStatus } from '../../../../utils';
import { trackActivity } from '../../../../utils/mixpanel';
import { fetchLeaseBasicDetails } from '../../../../shared_elements/actionCreators';
import { useDispatch } from 'react-redux';
import { regexConstants } from '../../../../constants/regEx';

const LessorCRU = ({ editLessor, onToggleModal, params, getResponseBack,modeType }) => {
    const dispatch = useDispatch()
    const [isLoading, setLoading] = useState(false);
    const [editLessorData, setEditLessordata] = useState({ ...editLessor?.data, contact: editLessor?.data?.lessor_phone_number, address: editLessor?.data?.lessor_contact_address });
    // const [lessorData, setLessorData] = useState([]);
    const [ownerData, setOwnerData] = useState([]);
    const [dropDownloader,setDropDownLoader]=useState({lessor:false,owner:false})
    const [error, setError] = useState({});
    const oldValue = useRef(null);

    useEffect(() => {
       if(modeType!=='view'){
            // getLessor();
            getOwner();
        }
    }, [])

    const handelEditLessor = () => {
        let validationInputs = {};
        validationInputs = {
            lessor_detail: editLessorData?.lessor_detail?.id ? "" : "Please select Lessor",
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            let payload = Object.assign({}, editLessorData);
            payload = {
                ...payload,
                lessor: null,
                owner_id: editLessorData?.owner
            }
            globalPutService(putLessorApi(params,{'cross_feature_check': 'lease_details'}), payload)
                .then(async (response) => {
                    if (checkApiStatus(response)) {
                        getResponseBack()
                        onToggleModal();
                        dispatch(fetchLeaseBasicDetails({ slug: params,setLoading}));
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Edited', { page_title: `Edit Lessor`, success_msg: response?.data?.message, item_slug: params, payload: payload, response: response?.data })
                    } else {
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } })
                        trackActivity('Item Edited', { page_title: `Edit Lessor`, error_msg: response?.data?.message, item_slug:params, payload: payload, response: response?.data })
                    }
                    setLoading(false);
                })
        }
        else {
            setError(validationInputs);
            trackActivity(`Item Edited`, { page_title: `Edit Lessor`, error_msg: validationInputs, })  
        }
    }

    // const getLessor = () => {
    //     setDropDownLoader(prev => ({ ...prev, lessor: true }));
    //     globalGetService(getLessorDropdown())
    //         .then(response => {
    //             setDropDownLoader(prev => ({ ...prev, lessor: false }));
    //             if (checkApiStatus(response)) {
    //                 setLessorData(response?.data?.data);
    //             }
    //         })
    // }
    const getOwner = () => {
        setDropDownLoader(prev => ({ ...prev, owner: true }));
        globalGetService(getOwnerDropdown())
            .then(response => {
                setDropDownLoader(prev => ({ ...prev, owner: false }));
                if (checkApiStatus(response)) {
                    setOwnerData(response?.data?.data);
                }
            })
    }

    const handleInputChange = (key, value) => {
        if (key === "lessor_detail") {
            setEditLessordata({
                ...editLessorData,
                lessor_detail: value,
                contact_address: value?.contact_address ? value?.contact_address : "",
                lessor_phone_number: value?.contact_phone_number?value?.contact_phone_number:null,
                lessor_jurisdiction: value?.jurisdiction ? value?.jurisdiction : "",
                lessor_contact_fax_number:value?.contact_fax?value?.contact_fax:null,
                lessor_contact_email:value?.contact_email?value?.contact_email:null,
                lessor_country_of_incorporation:value?.country_of_incorporation?value?.country_of_incorporation:null,
                lessor_name_id: value?.id || null,
            })
        }
        else {
            setEditLessordata({
                ...editLessorData,
                [key]: value
            })
        }
    }
const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `${modeType==='view'? 'View':'Edit'} Lessor`, page_type: page_type, })
  }
    return (
        <>
            <Dialog
                aria-labelledby="customized-dilog-title"
                className="add-lease-dialog"
                maxWidth="md"
                fullWidth
                open={editLessor.modal}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" className='dialog-header'>
                    <Typography className="dialog-header-title"> {modeType==='edit'?'Edit':'View'} Lessor</Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Autocomplete 
                            disableClearable
                             disablePortal
                              disabled={modeType === 'view'} 
                              options={ownerData} 
                              noOptionsText={dropDownloader?.owner ? "Loading..." : "No Option Available"} 
                              getOptionLabel={(option) => option?.name || ""} 
                              isOptionEqualToValue={(option, value) => option?.id === value?.id}
                               value={editLessorData?.lessor_detail || null} 
                               onChange={(event, newValue) => { handleInputChange("lessor_detail", newValue) }} 
                               onFocus={() => setError({ lessor_detail: "" })} 
                                onOpen={() => {
                                        oldValue.current = editLessorData?.lessor_detail || null;
                                        handleInputChange("lessor_detail", null);
                                    setEditLessordata({ ...editLessorData, lessor_detail: null })
                                    }}
                                    onClose={(_, reason) => {
                                        if (reason !== 'selectOption') {
                                            setEditLessordata({ ...editLessorData, lessor_detail: oldValue.current })
                                        }
                                    }}
                               slotProps={{ listbox: { style: { maxHeight: 180 } }, }}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                                            <TextField {...params} label="Name" variant='outlined' size='small' margin='normal' fullWidth required helperText={error.lessor_detail} error={error.lessor_detail}
                                                slotProps={{
                                                    inputLabel: { shrink: true, },
                                                    input: {
                                                        ...params?.InputProps, endAdornment: (<>{dropDownloader?.owner ? (<CircularProgress color="inherit" size={20} />) : null}
                                                            {params?.InputProps?.endAdornment}</>)
                                                    }
                                                }}
                                                placeholder={oldValue.current?.name ||'Select Lessor'} />
                                        </Tooltip>
                                    )
                                }} />
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Autocomplete disablePortal disabled={modeType === 'view'} options={ownerData} noOptionsText={dropDownloader?.owner ? "Loading..." : "No Option Available"} getOptionLabel={(option) => option?.name || ""} isOptionEqualToValue={(option, value) => option?.id === value?.id} value={editLessorData?.owner || null} onChange={(event, newValue) => { handleInputChange("owner", newValue) }} slotProps={{ listbox: { style: { maxHeight: 180 } }, }}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                                            <TextField {...params} label="Owner/SPV" variant='outlined' size='small' margin='normal' slotProps={{ inputLabel: { shrink: true, }, input: { ...params?.InputProps, endAdornment: (<>{dropDownloader?.owner ? (<CircularProgress color="inherit" size={20} />) : null}{params?.InputProps?.endAdornment}</>) } }} fullWidth placeholder='Select Owner' />
                                        </Tooltip>)
                                }}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                        <Tooltip title={editLessorData?.lessor_jurisdiction?.length > 23 ? editLessorData?.lessor_jurisdiction : ""} placement="bottom" arrow>   
                            <TextField
                                id='jurisdiction'
                                label="Jurisdiction"
                                value={editLessorData?.lessor_jurisdiction ? editLessorData.lessor_jurisdiction : ""}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 50 } }}
                                disabled={true}
                            />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                        <Tooltip title={editLessorData?.spv?.length > 23 ? editLessorData?.spv : ""} placement="bottom" arrow>   
                            <TextField
                                id='spv'
                                label="SPV"
                                value={editLessorData?.spv ? editLessorData.spv : ""}
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handleInputChange('spv', e.target.value) : e.preventDefault()}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                disabled={modeType === 'view'}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 50 } }}
                            />
                            </Tooltip>
                        </Grid>
                        {editLessorData?.ownership_type?.value === 2 &&
                        <Grid size={{ xs: 12, md: 4 }}>
                        <Tooltip title={editLessorData?.lessor_portfolio?.length > 23 ? editLessorData?.lessor_portfolio : ""} placement="bottom" arrow>   
                            <TextField
                                id='portfolio'
                                label="Portfolio"
                                value={editLessorData?.lessor_portfolio ? editLessorData?.lessor_portfolio:""}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                disabled
                                slotProps={{ inputLabel: { shrink: true } }}
                            />
                            </Tooltip>
                        </Grid>}
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Tooltip title={editLessorData?.lessor_country_of_incorporation?.length > 23 ? editLessorData?.lessor_country_of_incorporation : ""} placement="bottom" arrow>
                            <TextField
                                label="Country of Incorporation"
                                value={editLessorData?.lessor_country_of_incorporation ? editLessorData.lessor_country_of_incorporation : ""}
                                onChange={(e) => handleInputChange("lessor_jurisdiction", e.target.value)}
                                varient="outlined"
                                size='small'
                                disabled={true}
                                margin='normal'
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 100} }}
                                fullWidth />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Tooltip title={editLessorData?.lessor_contact_email?.length > 23 ? editLessorData?.lessor_contact_email : ""} placement="bottom" arrow>
                                <TextField
                                    label="Contact (Email)"
                                    variant='outlined'
                                    value={editLessorData?.lessor_contact_email ? editLessorData.lessor_contact_email : ""}
                                    disabled={true}
                                    size='small'
                                    margin='normal'
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    fullWidth />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <TextField
                                label="Contact (Phone)"
                                variant='outlined'
                                value={editLessorData?.lessor_phone_number ? editLessorData.lessor_phone_number : ""}
                                disabled={true}
                                size='small'
                                margin='normal'
                                slotProps={{ inputLabel: { shrink: true } }}
                                fullWidth />
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Tooltip title={editLessorData?.lessor_contact_fax_number?.length > 23 ? editLessorData?.lessor_contact_fax_number : ""} placement="bottom" arrow>
                                <TextField
                                    label="Contact (Fax)"
                                    variant='outlined'
                                    value={editLessorData?.lessor_contact_fax_number ? editLessorData.lessor_contact_fax_number : ""}
                                    disabled={true}
                                    size='small'
                                    margin='normal'
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    fullWidth />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ xs: 12, md: 12 }}>
                            <Tooltip title={editLessorData?.contact_address?.length > 23 ? editLessorData?.contact_address : ""} placement="bottom" arrow> 
                            <TextField
                                id='contactAddress'
                                label="Contact Address"
                                value={editLessorData?.contact_address ? editLessorData?.contact_address : ""}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                multiline
                                rows={3}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 255 } }}
                                disabled={true}
                            />
                            </Tooltip>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-action'>
                    <Button className='cancel-btn' variant='outlined' disabled={isLoading} size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null : <Button variant='contained' size='small' className='btn-primary' onClick={() => { handleItemClicked('Save Button'); handelEditLessor(); }}>{isLoading ? <CircularProgress color='inherit' size={24} /> : "Save"} </Button>}
                </DialogActions>
            </Dialog>
        </>
    )
}

export default LessorCRU;